import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ButtonColor } from '../../../store/models/button.model';
import { Styles } from '@fortawesome/fontawesome-svg-core';
import { environment } from '../../../../environments/environment';

export interface IMenuButton {
  label: string;
  routerLink: string;
  color: ButtonColor;
}

@Component({
  selector: 'app-retreva-minimal',
  templateUrl: './retreva-minimal.component.html',
  styleUrls: ['./retreva-minimal.component.scss'],
})
export class RetrevaMinimalComponent implements OnInit {
  isProduction = environment.production;
  showMenuButtons: boolean;

  menuButtons: IMenuButton[] = [
    {
      label: 'login',
      routerLink: '/login',
      color: ButtonColor.ORANGE,
    },
    {
      label: 'sign up',
      routerLink: '/register',
      color: ButtonColor.BLUE,
    },
  ];
  bars = faBars;

  mobileIconStyles: Styles = {
    padding: '5px',
    'background-color': '#f8a920',
    color: 'white',
    'border-radius': '5px',
    width: '36px',
  };

  mobileMenuShown: boolean;

  constructor(private readonly activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.activatedRoute.url.subscribe(
      () =>
        (this.showMenuButtons =
          ['home', 'login', 'register', 'reset-password', 'forgot_password', 'terms'].indexOf(
            this.activatedRoute.snapshot.routeConfig.path,
          ) !== -1),
    );
  }

  toggleLeftMenu() {
    this.mobileMenuShown = !this.mobileMenuShown;
    this.bars = this.mobileMenuShown ? faTimes : faBars;
  }
}
